var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0357 13.0003V7.66979C17.0373 6.01741 16.4324 4.42336 15.3385 3.19709C14.2445 1.97082 12.7395 1.19981 11.1156 1.03375C9.49176 0.867687 7.86487 1.31842 6.55078 2.29843C5.23669 3.27845 4.32916 4.71784 4.00438 6.33717",
    stroke: "#183171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02687 15.7905C7.02687 16.6799 7.45777 17.4633 8.1155 18.01V18.5812C8.1155 19.8278 9.26927 20.7091 10.52 20.7091C11.7707 20.7091 12.9245 19.8278 12.9245 18.5812V18.0097C13.5812 17.4637 14.0128 16.6806 14.0128 15.7905C14.0128 14.0314 12.3716 12.7322 10.5198 12.7322C8.66799 12.7322 7.02687 14.0314 7.02687 15.7905ZM10.9775 16.3497C10.7976 16.4388 10.6392 16.5681 10.5202 16.7269C10.4011 16.5682 10.2428 16.439 10.0632 16.3498L10.0623 16.3494C9.79058 16.2153 9.65974 15.9943 9.65974 15.7903C9.65974 15.4952 9.96883 15.1274 10.5202 15.1274C11.0716 15.1274 11.3807 15.4952 11.3807 15.7903C11.3807 15.9943 11.2498 16.2152 10.9781 16.3494L10.9775 16.3497ZM17.0499 10.9414C18.5035 10.9414 19.5429 11.9335 19.5429 12.9996V20.4418C19.5429 21.508 18.5033 22.5 17.0499 22.5H3.99008C2.53652 22.5 1.49713 21.5079 1.49713 20.4418V12.9996C1.49713 11.9334 2.53666 10.9414 3.99008 10.9414H17.0499Z",
    fill: "#183171",
    stroke: "#183171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default __webpack_public_path__ + "static/media/lockedIcon.09cf10a5b79106474bd7f6b533dba109.svg";
export { ForwardRef as ReactComponent };